import { createContext, useContext, useMemo } from 'react';

const LandingContext = createContext();

export const LandingProvider = ({
  accountName,
  actionsItems,
  arrivalLocation,
  attachedFiles,
  attachments,
  externalUrl,
  attachedImages,
  attachedVideos,
  attendees,
  cancelled = false,
  categories,
  children,
  comments,
  companyName,
  content,
  contractTypeName,
  coverPicture,
  createdAt,
  currency,
  dailySalary,
  departureLocation,
  displayCommentsByDefault,
  duration,
  embed,
  endDate,
  experienceTypeName,
  fromRecord,
  handleShare,
  handleShowUser,
  hasHeader = true,
  hasSocialOptions,
  id,
  isActive,
  isRowVisibleOrOutOfView,
  itemUrl,
  labelledById,
  lastContributors,
  likes,
  location,
  logo,
  logoUrl,
  // To remove with `flag-ujb-lf-pagination` cleanup
  measure,
  monthlySalary,
  onToggleComments,
  onTogglePostLike,
  onUpdateItem,
  originalType,
  owner,
  participantDisplayThreshold,
  pinned,
  postContent,
  publishedAt,
  shareUrl,
  startDate,
  surveyContent,
  timezone,
  title,
  topic,
  totalAttendees,
  totalComments,
  totalExternalAttendees,
  totalVisibleAttendees,
  totalVisibleYesResponses,
  transportation,
  type,
  ventureContent,
  yearlySalary,
}) => {
  const values = useMemo(
    () => ({
      accountName,
      actionsItems,
      arrivalLocation,
      attachedFiles,
      attachments,
      externalUrl,
      attachedImages,
      attachedVideos,
      attendees,
      cancelled,
      categories,
      comments,
      companyName,
      content,
      contractTypeName,
      coverPicture,
      createdAt,
      currency,
      dailySalary,
      departureLocation,
      displayCommentsByDefault,
      duration,
      embed,
      endDate,
      experienceTypeName,
      fromRecord,
      handleShare,
      handleShowUser,
      hasHeader,
      hasSocialOptions,
      id,
      isActive,
      isRowVisibleOrOutOfView,
      itemUrl,
      labelledById,
      lastContributors,
      likes,
      location,
      logo,
      logoUrl,
      measure,
      monthlySalary,
      onToggleComments,
      onTogglePostLike,
      onUpdateItem,
      originalType,
      owner,
      participantDisplayThreshold,
      pinned,
      postContent,
      publishedAt,
      shareUrl,
      startDate,
      surveyContent,
      timezone,
      title,
      topic,
      totalAttendees,
      totalComments,
      totalExternalAttendees,
      totalVisibleAttendees,
      totalVisibleYesResponses,
      transportation,
      type,
      ventureContent,
      yearlySalary,
    }),
    [
      accountName,
      actionsItems,
      arrivalLocation,
      attachedFiles,
      attachments,
      externalUrl,
      attachedImages,
      attachedVideos,
      attendees,
      cancelled,
      categories,
      comments,
      companyName,
      content,
      contractTypeName,
      coverPicture,
      createdAt,
      currency,
      dailySalary,
      departureLocation,
      displayCommentsByDefault,
      duration,
      embed,
      endDate,
      experienceTypeName,
      fromRecord,
      handleShare,
      handleShowUser,
      hasHeader,
      hasSocialOptions,
      id,
      isActive,
      isRowVisibleOrOutOfView,
      itemUrl,
      labelledById,
      lastContributors,
      likes,
      location,
      logo,
      logoUrl,
      measure,
      monthlySalary,
      onToggleComments,
      onTogglePostLike,
      onUpdateItem,
      originalType,
      owner,
      participantDisplayThreshold,
      pinned,
      postContent,
      publishedAt,
      shareUrl,
      startDate,
      surveyContent,
      timezone,
      title,
      topic,
      totalAttendees,
      totalComments,
      totalExternalAttendees,
      totalVisibleAttendees,
      totalVisibleYesResponses,
      transportation,
      type,
      ventureContent,
      yearlySalary,
    ],
  );

  return (
    <LandingContext.Provider value={values}>{children}</LandingContext.Provider>
  );
};

export const useLandingContext = () => useContext(LandingContext);

export const withLandingContext = (Component) => (props) => {
  const contextValue = useLandingContext();

  return <Component {...contextValue} {...props} />;
};
